export const searchPath = '/market/search/';
export const purinaCallUrl = 'https://www.careline.purina.ru/#call';
export const addPetPath = '/my/pets/add/';
export const uploadContestPhoto = '/user/upload-contest-photo/';
export const deleteContestPhoto = '/user/delete-contest-photo/';
